import { Routes, Route } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import Orders from './Orders'; // your only orders file
import Dashboard from './Dashboard'; // just a placeholder page
import Users from './Users';
import Restaurant from './Restaurant';
import RestaurantApplications from './RestaurantApplications';
import StoreCategories from './StoreCategories';



const AdminApp = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        {/* <Route path="orders" element={<Orders />} /> */}
        <Route path="users" element={<Users />} />
        <Route path="restaurant" element={<Restaurant />} />
        <Route path="categories" element={<StoreCategories />} />
        <Route path="restaurant-applications" element={<RestaurantApplications />} />

      </Route>
    </Routes>
  );
};

export default AdminApp;
